import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import { FaRegComment } from 'react-icons/fa';
import { FiEdit, RiDeleteBin6Line } from 'react-icons/fi';
import { truncate } from 'lodash';
import { HelmetProvider } from 'react-helmet-async';


const DetailStoryContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 60px;
  font-size: 20px;
`;

const ArticleDate = styled.p`
  line-height: 1.28577;
    font-weight: 600;
    letter-spacing: -.016em;
  color: #5c5b5b;
`;

const ArticleTitle = styled.h1`
  font-size: 36px;
   line-height: 1.125;
  font-weight: 600;
  letter-spacing: 0.005em;
  /* margin: 10px 0;  */
  max-height: max-content;
`;

const ShortDescription = styled.p`
      font-size: 21px;
    line-height: 1.19048;
    font-weight: 500;
    letter-spacing: .011em;
  color: #555;
  margin-top: 50px;
`;

const ImagePlaceholder = styled.div`
  width: 100%;
  height: 300px; /* Adjust height as needed */
  background-color: #ddd; /* Placeholder color */
  margin: 20px 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ensure the image covers the div */
  }
`;

const ArticleContent = styled.div`
  font-size: 18px;
  line-height: 1.6;
  color: #333;
  margin-top: 20px;
`;

const StoryGeneralInfo = styled.div`
  width: 100%;
  height: 45px;
  background-color: #f4f7fd;
  display: flex;
  justify-content: space-between;
  padding: 0 18px;
  position: relative;
`;

const CommentInfoWrap = styled.div`
  display: flex;
  align-items: center;
`;

const CommentCount = styled.b`
  margin-left: 5px;
`;

const TopStoryTransactions = styled.div`
  display: flex;
  align-items: center;
`;

const EditStoryLink = styled(Link)`
  margin-right: 10px;
`;

const DeleteStoryLink = styled.span`
  cursor: pointer;
`;

const DetailStory = () => {
  const navigate = useNavigate();
  const [likeStatus, setLikeStatus] = useState(false)
  const [likeCount, setLikeCount] = useState(0)
  const [activeUser, setActiveUser] = useState({})
  const [story, setStory] = useState({})
  const [storyLikeUser, setStoryLikeUser] = useState([])
  const [sidebarShowStatus, setSidebarShowStatus] = useState(false)
  const [loading, setLoading] = useState(true)
  const slug = useParams().slug
  const [storyReadListStatus, setStoryReadListStatus] = useState(false)
  const [helmetContent, setHelmetContent] = useState(null)


  useEffect(() => {
  

    const getDetailStory = async () => {
      setLoading(true)
      var activeUser = {}
      try {
        const { data } = await axios.get("/auth/private", {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });
        activeUser = data.user

        setActiveUser(activeUser)

      }
      catch (error) {
        setActiveUser({})
      }

      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/story/${slug}`, { activeUser })

        // Set meta tags dynamically using React Helmet
        if (data.data) {
          const story = data.data;
          const pageTitle = story.title; // Title for the page
          const metaDescription = story.description; // Description for the page
          // Update Helmet with dynamic meta tags
          const helmetContent = (
            <Helmet>
              <title>{pageTitle}</title>
              <meta name="tester" content={metaDescription} />
              {/* Add other meta tags as needed */}
            </Helmet>
          );
        
          setHelmetContent(helmetContent);
        }

        setStory(data.data)
        setLikeStatus(data.likeStatus)
        setLikeCount(data.data.likeCount)
        setStoryLikeUser(data.data.likes)
        setLoading(false)

        const story_id = data.data._id;

        if (activeUser.readList) {

          if (!activeUser.readList.includes(story_id)) {
            setStoryReadListStatus(false)
          }
          else {
            setStoryReadListStatus(true)

          }

        }

      }
      catch (error) {
        setStory({})
        navigate("/not-found")
      }

    }
    getDetailStory();

  }, [slug, setLoading])



  const handleLike = async () => {
    setTimeout(() => {
      setLikeStatus(!likeStatus)
    }, 1500)

    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/story/${slug}/like`, { activeUser }, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })

      setLikeCount(data.data.likeCount)
      setStoryLikeUser(data.data.likes)

    }
    catch (error) {
      setStory({})
      localStorage.removeItem("authToken")
      navigate("/")
    }

  }

  const handleDelete = async () => {

    if (window.confirm("Do you want to delete this post")) {

      try {

        await axios.delete(`${process.env.REACT_APP_API_URL}/story/${slug}/delete`, {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
        navigate("/")

      }
      catch (error) {
        console.log(error)
      }

    }

  }


  const editDate = (createdAt) => {
    if(!createdAt) return '';
    const d = new Date(createdAt);
    var datestring = d.toLocaleString('eng', { month: 'long' }).substring(0, 3) + " " + d.getDate();
    return String(datestring);
  }

  const addStoryToReadList = async () => {

    try {

      const { data } = await axios.post(`/user/${slug}/addStoryToReadList`, { activeUser }, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })

      setStoryReadListStatus(data.status)

      document.getElementById("readListLength").textContent = data.user.readListLength
    }
    catch (error) {
      console.log(error)
    }
  }
 

  return (
    <HelmetProvider>
      <Helmet>
        <title>{story?.title}</title>
        <meta name="keyword" content={story.metaKeywords}></meta>
        <meta name="description" content={story.metaDescription} />
        <meta property="twitter:title" content={story.title} />
        <meta property="twitter:description" content={story.metaDescription} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="og:title" content={story.title} />
        <meta property="og:description" content={story.metaDescription} />
        <meta property="og:image" content={story.image} />
        {/* Add more meta tags or other head elements as needed */}
      </Helmet>
      <DetailStoryContainer>
        <ArticleDate>{editDate(story.createdAt)} </ArticleDate>
        <ArticleTitle>{story.title}</ArticleTitle>
        <ShortDescription>{story.description}</ShortDescription>
        <ImagePlaceholder> 
          <img
            src={`${story.image}`}
            alt="Description"
          />
        </ImagePlaceholder>
        <ArticleContent dangerouslySetInnerHTML={{ __html: story.content }} />
      </DetailStoryContainer>
    </HelmetProvider>
  );
};

export default DetailStory;
